import { DATA, KEY, Resource } from "shelving";
import { CREATOR_ENTITY } from "../schema/entity.js";

export const JOIN_LEADERBOARD = new Resource("joinLeaderboard", DATA({ creator: CREATOR_ENTITY, cid: KEY }));
export const LEAVE_LEADERBOARD = new Resource("leaveLeaderboard", DATA({ creator: CREATOR_ENTITY, cid: KEY }));
